<template>
  <PageTitleComponent />
  <div class="ranges">
    <div class="container">
      <div class="row justify-content-center">
        <div
          v-for="range in ranges"
          :key="range.id"
          class="col-md-4 text-center"
        >
          <RangeCardComponent :range="range" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "pinia";
import PageTitleComponent from "@/components/PageTitleComponent.vue";
import RangeCardComponent from "@/components/RangeCardComponent.vue";
import { useMainStore } from "@/store";

export default {
  name: "ModelView",
  components: { RangeCardComponent, PageTitleComponent },
  computed: {
    ...mapState(useMainStore, {
      ranges: (store) => store.ranges,
    }),
  },
};
</script>

<style lang="scss" scoped>
.container {
  max-width: 1600px;
}

.ranges {
  display: flex;
  justify-content: center;
  align-items: center;
  color: $white;
  height: 100%;
}
</style>
